import { writable } from "svelte/store";

export const showDialPad = writable(false);
